(() => {
  const root = document.getElementById('cb-chat');
  if (!root || root.dataset.boot) return;
  root.dataset.boot = '1';
  const get = (store, k) => { try { return window[store].getItem(k); } catch (e) { return null; } };
  const set = (store, k) => { try { window[store].setItem(k, '1'); } catch (e) {} };
  let loading;
  const add = (tag, attrs) => new Promise((ok) => { const n = Object.assign(document.createElement(tag), attrs); n.onload = n.onerror = ok; document.head.append(n); });
  const load = () => loading || (loading = Promise.all([
    add('link', { rel: 'stylesheet', href: root.dataset.css }),
    add('script', { src: root.dataset.src }),
  ]));
  const launch = root.querySelector('.cb-chat__launch');
  const peek = root.querySelector('.cb-chat__peek');
  const timers = [];
  const stop = () => { timers.forEach((t) => { clearTimeout(t); clearInterval(t); }); peek.hidden = true; launch.classList.remove('is-petals'); };
  // Until cb-chat.js is in, this opens it; if loading failed, the next tap tries again. Once loaded, cb-chat.js handles the button.
  const open = () => {
    stop();
    set('localStorage', 'cb-chat-opened');
    if (window.cbChat) return;
    load().then(() => { if (window.cbChat) window.cbChat.open(); else loading = null; });
  };
  launch.addEventListener('click', open);
  // "Continue the chat" link from a reply email: the key lives in the hash, removed before analytics start.
  const resume = /^#cb-chat=([0-9a-f]{32})$/.exec(location.hash);
  if (resume) {
    history.replaceState(null, '', location.pathname + location.search);
    window.cbChatResume = resume[1];
    set('localStorage', 'cb-chat-opened');
    load();
    return;
  }
  peek.addEventListener('click', () => { if (window.cbChat) { stop(); window.cbChat.open(); } else open(); });
  // Only a conversation from the last 24 hours needs the chat ready on every page; older ones load on click
  // (florist replies also go by email). An old visit leaves just the name.
  let saved = {};
  try { saved = JSON.parse(get('localStorage', 'cb-chat') || '{}') || {}; } catch (e) {}
  if (saved.conv && Date.now() - (saved.at || 0) < 24 * 3600000) { load(); return; }
  if (saved.conv) return;
  if (saved.name) return;
  if (get('localStorage', 'cb-chat-opened')) return;

  // Shop hours: window.cbTime (CB Time settings)
  const s = cbTime.shop();
  const isOpen = s.open;
  const at = s.opens;
  root.classList.toggle('is-closed', !isOpen);
  peek.querySelectorAll('[data-open]').forEach((n) => { n.textContent = n.dataset[isOpen ? 'open' : 'closed'].replace('[time]', at); });

  const quiet = matchMedia('(prefers-reduced-motion: reduce)').matches;
  timers.push(setTimeout(() => {
    if (!get('sessionStorage', 'cb-chat-hint')) {
      set('sessionStorage', 'cb-chat-hint');
      peek.hidden = false;
      timers.push(setTimeout(() => { peek.hidden = true; }, 7000));
    }
    // Bursts repeat every 6 s by CSS (animation cycle), no timer
    if (!quiet) launch.classList.add('is-petals');
  }, 5000));
})();

